import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { LogSearchParams, MessageLog, Participant, Service } from 'app/integration/message-log/services/message-log';
import { SearchResult } from '@heda/core-util';
import { SearchHttpParams } from '@heda/core-util';

@Injectable()
export class MessageLogService {
  protected baseUrl = `${environment.estnhsApi}/integration`;

  constructor(private http: HttpClient) {}

  getLog(id: string): Observable<MessageLog> {
    const url = `${this.baseUrl}/message-logs/${id}`;
    return this.http.get(url).pipe(map((resp) => resp as MessageLog));
  }

  query(params: LogSearchParams): Observable<SearchResult<MessageLog>> {
    const p: any = Object.assign({}, params);
    return this.http
      .get(`${this.baseUrl}/message-logs`, { params: SearchHttpParams.build(p) })
      .pipe(map((resp) => resp as SearchResult<MessageLog>));
  }

  getServices(): Observable<Array<Service>> {
    const url = `${this.baseUrl}/services `;
    return this.http.get(url).pipe(map((resp) => resp as Array<Service>));
  }

  getParticipants(): Observable<Array<Participant>> {
    const url = `${this.baseUrl}/participants `;
    return this.http.get(url).pipe(map((resp) => resp as Array<Participant>));
  }

  resend(logId: string): Observable<string> {
    return this.http.post(`${this.baseUrl}/message-logs/${logId}/resend`, null).pipe(map((v) => v as string));
  }
}
